module.exports = __webpack_public_path__ + "img/Sethiwan Group.00137e4d.png";